import { Box, Card, CardContent, Typography, Grid } from "@mui/material"
import { TrendingUp, AttachMoney, BarChart, CreditCard, People, Inventory, ShoppingCart } from "@mui/icons-material"

import { useEffect, useState } from "react"
import axios from "axios"

import BaseURL from "../../api/AppURL";

const DashboardCards = () => {

  const [accountData, setAccountData] = useState(null)
  const [todaySale, setTodaySale] = useState(null)
  const [weeklySale, setWeeklySale] = useState(null)
  const [monthlySale, setMonthlySale] = useState(null)
  const [yearlySale, setYearlySale] = useState(null)
  const [todayPayment, setTodayPayment] = useState(null)
  const [weeklyPayment, setWeeklyPayment] = useState(null)
  const [monthlyPayment, setMonthlyPayment] = useState(null)
  const [yearlyPayment, setYearlyPayment] = useState(null)
  const [totalDue, setTotalDue] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchDashboard = async () => {
      setLoading(true)
      setError(null)
      try {
        const token = localStorage.getItem("auth_token") // টোকেন নিয়ে আসা
        const response = await axios.get(`${BaseURL}/admin/dashboard`, {
          headers: {
            Authorization: `Bearer ${token}`, // এখানে হেডার অ্যাড
            Accept: "application/json",
          },
        })
        if (response.data.success) {
          setAccountData(response.data.account_records)
          setTodaySale(response.data.todaySale)
          setWeeklySale(response.data.weeklySales)
          setMonthlySale(response.data.monthlySales)
          setYearlySale(response.data.yearlySales)
          setTodayPayment(response.data.todayPayments)
          setWeeklyPayment(response.data.weeklyPayments)
          setMonthlyPayment(response.data.monthlyPayments)
          setYearlyPayment(response.data.yearlyPayments)
          setTotalDue(response.data.totalDue)
        }
      } catch (err) {
        console.error("Error fetching dashboard:", err)
        setError("Failed to load dashboard data.")
      } finally {
        setLoading(false)
      }
    }

    fetchDashboard()
  }, [])

  if (loading) return <p>Loading...</p>
  if (error) return <p>{error}</p>

  const dashboardCards = [
    {
      // সোলিড ব্লু (Primary Blue)
      title: "Today's Sales",
      value: todaySale !== null && todaySale !== undefined ? `৳ ${todaySale}` : "Loading...",
      change: "+12%",
      color: "#1976d2",
      icon: TrendingUp,
    },
    {
      // ডার্ক গ্রিন
      title: "Weekly Sales",
      value: weeklySale !== null && weeklySale !== undefined ? `৳ ${weeklySale}` : "Loading...",
      change: "+8%",
      color: "#388e3c",
      icon: AttachMoney,
    },
    {
      //ডার্ক পার্পল
      title: "Monthly Sales",
      value: monthlySale !== null && monthlySale !== undefined ? `৳ ${monthlySale}` : "Loading...",
      change: "+15%",
      color: "#7b1fa2",
      icon: BarChart,
    },
    {
      //ডার্ক অরেঞ্জ
      title: "Yearly Sales",
      value: yearlySale !== null && yearlySale !== undefined ? `৳ ${yearlySale}` : "Loading...",
      change: "+23%",
      color: "#f57c00",
      icon: TrendingUp,
    },
    {
      // ডার্ক টার্কোয়াইজ গ্রিন
      title: "Today's Payments Received",
      value: todayPayment !== null && todayPayment !== undefined ? `৳ ${todayPayment}` : "Loading...",
      change: "+5%",
      color: "#00796b",
      icon: CreditCard,
    },
    {
      title: "Weekly Payments Received",
      value: weeklyPayment !== null && weeklyPayment !== undefined  ? `৳ ${weeklyPayment}` : "Loading...",
      change: "+7%",
      color: "#303f9f",
      icon: CreditCard,
    },
    {
      //ডার্ক পিঙ্ক
      title: "Monthly Payments Received",
      value: monthlyPayment !== null && monthlyPayment !== undefined  ? `৳ ${monthlyPayment}` : "Loading...",
      change: "+10%",
      color: "#c2185b",
      icon: CreditCard,
    },
    {
      //ডার্ক রেড
      title: "Yearly Payments Received",
      value: yearlyPayment !== null && yearlyPayment !== undefined ? `৳ ${yearlyPayment}` : "Loading...",
      change: "+18%",
      color: "#d32f2f",
      icon: CreditCard,
    },
    {
      // মিডিয়াম গ্রিন
      title: "Due This Year",
      value: totalDue !== null && totalDue !== undefined ? `৳ ${totalDue}` : "Loading...",
      change: "+18%",
      color: "#43a047",
      icon: CreditCard,
    },
    {
      title: "Current Account Balance",
      value: accountData !== null && accountData !== undefined  ? `৳ ${accountData.current_balance}` : "Loading...",
      change: "+18%",
      color: "#ff0000",
      icon: CreditCard,
    },
    {
      title: "Total Customers",
      value: "1,234",
      change: "+6%",
      color: "#0097a7",
      icon: People,
    },
    {
      title: "Total Products",
      value: "896",
      change: "+3%",
      color: "#689f38",
      icon: Inventory,
    },
    {
      //হালকা অরেঞ্জ
      title: "Pending Orders",
      value: "45",
      change: "-2%",
      color: "#ffa000",
      icon: ShoppingCart,
    },
    {
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#e64a19",
      icon: Inventory,
    },
    {
      // 1e88e5
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#1e88e5",
      icon: Inventory,
    },
    {
      // স্কাই ব্লু
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#64b5f6",
      icon: Inventory,
    },
    {
      // টার্কোয়াইজ
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#00bcd4",
      icon: Inventory,
    },
    {
      // ডার্ক টার্কোয়াইজ
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#0097a7",
      icon: Inventory,
    },
    {
      // লাইট গ্রিন
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#81c784",
      icon: Inventory,
    },
    {
      // সোলিড গ্রিন
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#4caf50",
      icon: Inventory,
    },
    {
      // সোলিড রেড
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#f44336",
      icon: Inventory,
    },
    {
      // লাইট রেড
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#e57373",
      icon: Inventory,
    },
    {
      // লাইট পিঙ্ক
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#f06292",
      icon: Inventory,
    },
    {
      // মিডিয়াম পার্পল
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#9c27b0",
      icon: Inventory,
    },
    {
      // ডার্ক পার্পল
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#ba68c8",
      icon: Inventory,
    },
    {
      // সোলিড অরেঞ্জ
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#ff9800",
      icon: Inventory,
    },
    {
      // ডার্ক গ্রে
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#616161",
      icon: Inventory,
    },
    {
      // মিডিয়াম গ্রে
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#9e9e9e",
      icon: Inventory,
    },
    {
      // প্রায় ব্ল্যাক
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#212121",
      icon: Inventory,
    },
    {
      // লাইট গ্রে
      title: "Stock Out",
      value: "12",
      change: "+1%",
      color: "#e0e0e0",
      icon: Inventory,
    },
  ]

  return (
    <Grid container spacing={3}>
      {dashboardCards.map((card, index) => {
        const Icon = card.icon
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                height: "100%",
                background: `linear-gradient(135deg, ${card.color} 0%, ${card.color}dd 100%)`,
                color: "white",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                  <Box>
                    <Typography variant="body2" sx={{ opacity: 0.9, mb: 1 }}>
                      {card.title}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      {card.value}
                    </Typography>
                  </Box>
                  <Icon sx={{ fontSize: 32, opacity: 0.8 }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: card.change.startsWith("+") ? "#c8e6c9" : "#ffcdd2",
                    fontWeight: "medium",
                  }}
                >
                  {card.change} from last month
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default DashboardCards
